/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import DocsLayout from '../../components/DocsLayout';
import Nesting from '../../sections/faqs/nesting.mdx';
import CSSFrameworks from '../../sections/faqs/support-for-css-frameworks.mdx';
import OverrideStyles from '../../sections/faqs/override-styles-with-higher-specificity.mdx';
import OverrideInlineStyles from '../../sections/faqs/override-inline-styles.mdx';
import TwoDomClasses from '../../sections/faqs/dom-two-classes.mdx';
import WhenToUseAttrs from '../../sections/faqs/when-to-use-attrs.mdx';
import LibraryAuthors from '../../sections/faqs/library-authors.mdx';
import DuplicatedStyledComponents from '../../sections/faqs/duplicated-styled-components.mdx';
import HTMLAttributeWarnings from '../../sections/faqs/html-attribute-warnings.mdx';
import BrowserSupport from '../../sections/faqs/browser-support.mdx';
import MigrationV4 from '../../sections/faqs/migration-v4.mdx';
import MigrationV5 from '../../sections/faqs/migration-v5.mdx';
import MigrationV6 from '../../sections/faqs/migration-v6.mdx';
import CRA from '../../sections/faqs/create-react-app.mdx';
import NPMLink from '../../sections/faqs/npm-link.mdx';
import FlickeringText from '../../sections/faqs/flickering-text.mdx';
import DeclareComponentsInRenderMethod from '../../sections/faqs/declare-components-in-render-method.mdx';
import MissingNativeImport from '../../sections/faqs/missing-native-import.mdx';
const MDXLayout = ({children}) => _jsx(DocsLayout, {
  title: "FAQs",
  description: "Commonly asked questions about styled-components",
  children: children
});
function _createMdxContent(props) {
  return _jsxs(_Fragment, {
    children: [_jsx(MigrationV6, {}), "\n", _jsx(MigrationV5, {}), "\n", _jsx(MigrationV4, {}), "\n", _jsx(Nesting, {}), "\n", _jsx(CSSFrameworks, {}), "\n", _jsx(OverrideStyles, {}), "\n", _jsx(OverrideInlineStyles, {}), "\n", _jsx(TwoDomClasses, {}), "\n", _jsx(WhenToUseAttrs, {}), "\n", _jsx(LibraryAuthors, {}), "\n", _jsx(DuplicatedStyledComponents, {}), "\n", _jsx(DeclareComponentsInRenderMethod, {}), "\n", _jsx(HTMLAttributeWarnings, {}), "\n", _jsx(BrowserSupport, {}), "\n", _jsx(CRA, {}), "\n", _jsx(NPMLink, {}), "\n", _jsx(FlickeringText, {}), "\n", _jsx(MissingNativeImport, {})]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
